import { render } from "./share-knowledge.vue?vue&type=template&id=3c44a0a8"
import script from "./share-knowledge.vue?vue&type=script&lang=js"
export * from "./share-knowledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__